(function () {
    'use strict';

    angular.module('plagiat2017App')
    .factory('searchRequest', function () {

        function searchRequest() {
            this.pageNumber = 0;
            this.pageSize = 5;
            this.sortTab = '';
            this.showOnlyForUser = true;
            this.search = {};
        }

        return searchRequest;
    });
})();